import React, { createContext, useContext, useState, useCallback } from 'react';
import EarlyAccessModal from '../components/pilot/EarlyAccessModal';

const EarlyAccessContext = createContext(null);

export function EarlyAccessProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [openSource, setOpenSource] = useState(null); // 'pulse' | 'radar' | 'designer' | null

  const openEarlyAccessModal = useCallback((source = null) => {
    setOpenSource(source);
    setIsOpen(true);
  }, []);
  const closeEarlyAccessModal = useCallback(() => {
    setIsOpen(false);
    setOpenSource(null);
  }, []);

  return (
    <EarlyAccessContext.Provider value={{ openEarlyAccessModal }}>
      {children}
      <EarlyAccessModal isOpen={isOpen} onClose={closeEarlyAccessModal} openSource={openSource} />
    </EarlyAccessContext.Provider>
  );
}

export function useEarlyAccess() {
  const ctx = useContext(EarlyAccessContext);
  return ctx || { openEarlyAccessModal: () => {} };
}
